import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SessionUpload from '../session-upload/SessionUpload';
import SessionUploadManager from '../session-upload/SessionUploadManager';
import EventListTable from '../event-list/EventListTable';
import SessionViewer from '../session-viewer/SessionViewer';
import {
  SessionViewerWrapper,
  SessionComparison,
} from '../session-viewer-enhanced';

export function ViewerTop() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [selectedSession, setSelectedSession] = React.useState({
    // Video data
    videoDataId: null,
    carNum: null,
    username: null,
    cameraAngle: null,

    // Session data
    sessionId: null,
    sessionName: null,
    trackConfig: null,

    // Event data
    eventId: null,
    eventName: null,
    eventVenue: null,
    eventDate: null,

    // Status indicators
    hasVideo: false,
    hasTelemetry: false,
    hasLaptimes: false,
  });
  const [comparisonVideos, setComparisonVideos] = React.useState({
    videoA: null,
    videoB: null,
    sessionMetadata: null,
  });
  const [vidUploadProgressPercent, setVidUploadProgressPercent] =
    React.useState(0);

  function liftVidUploadProgressPercent(p) {
    setVidUploadProgressPercent(p);
  }

  function liftCreatingSession(s) {
    setActiveStep(s === false ? 0 : s);
  }

  function liftSelectedSession(s) {
    setSelectedSession(s);
  }

  function liftComparisonVideos(videoA, videoB, sessionMetadata) {
    setComparisonVideos({ videoA, videoB, sessionMetadata });
    setActiveStep(5); // Navigate to comparison view
  }

  // Four modes: EventListTable (replaced RunTable), SessionUpload, SessionUploadManager, and SessionViewer
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <EventListTable
            liftCreatingSession={liftCreatingSession}
            liftSelectedSession={liftSelectedSession}
          />
        );
      case 1:
        return (
          <SessionUpload
            liftCreatingSession={liftCreatingSession}
            liftVidUploadProgressPercent={liftVidUploadProgressPercent}
          />
        );
      case 2:
        return (
          <SessionViewer
            liftCreatingSession={liftCreatingSession}
            liftSelectedSession={liftSelectedSession}
            selectedSession={selectedSession}
          />
        );
      case 3:
        return <SessionUploadManager onClose={() => setActiveStep(0)} />;
      case 4:
        return (
          <SessionViewerWrapper
            liftCreatingSession={liftCreatingSession}
            liftSelectedSession={liftSelectedSession}
            selectedSession={selectedSession}
            liftComparisonVideos={liftComparisonVideos}
          />
        );
      case 5:
        return (
          <Box
            sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
          >
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
              <SessionComparison
                liftCreatingSession={liftCreatingSession}
                liftSelectedSession={liftSelectedSession}
                videoIdA={comparisonVideos.videoA}
                videoIdB={comparisonVideos.videoB}
                sessionMetadata={comparisonVideos.sessionMetadata}
              />
            </Box>
          </Box>
        );
      default:
        throw new Error('Unknown step');
    }
  }

  return (
    <React.Fragment>
      {activeStep !== 2 && activeStep !== 4 && activeStep !== 5 && (
        <Box sx={{ flexGrow: 1, border: '2px solid orange' }}>
          <Toolbar>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
            ></Typography>
            <Button
              onClick={() => setActiveStep(1)}
              variant="contained"
              endIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add (Old)
            </Button>
            <Button
              onClick={() => setActiveStep(3)}
              variant="contained"
              color="secondary"
              endIcon={<UploadFileIcon />}
              sx={{ mr: 1 }}
            >
              Add (New)
            </Button>
          </Toolbar>
        </Box>
      )}
      {getStepContent(activeStep)}
    </React.Fragment>
  );
}
